//  PRIMARY
const primary = {
  "1000": "#081012",
  "900": "#1a2d30",
  "800": "#2a474b",
  "700": "#386066",
  "600": "#4b7e86",
  "500": "#69adb5",
  "400": "#82cbd3",
  "300": "#b7e2e6",
  "200": "#d9eff1",
  "100": "#f4fbfb",
  alpha: (alpha: number) => `rgba(47, 186, 195, ${alpha})`,
}

// NATURAL
const grey = {
  "1000": "#141415",
  "900": "#2d2d2f",
  "800": "#414144",
  "700": "#57575b",
  "600": "#75757a",
  "500": "#a4a4a8",
  "400": "#cbcbd2",
  "300": "#e5e5eb",
  "200": "#f1f1f4",
  "100": "#f7f7f8",
  alpha: (alpha: number) => `rgba(25, 25, 28, ${alpha})`, // 900기준
}
const platinum = {
  "1000": "#0a1316",
  "900": "#1a2c34",
  "800": "#2d4753",
  "700": "#435d6b",
  "600": "#6d7d8a",
  "500": "#aabaca",
  "400": "#b8c9db",
  "300": "#dce3ea",
  "200": "#eff3f4",
  "100": "#f8fafc",
  alpha: (alpha: number) => `rgba(113, 113, 122, ${alpha})`,
}

// ALPHA
const alpha = {
  "black-75": "#000000bf",
  "black-20": "#00000033",
  "black-12": "#0000001f",
  "black-08": "#00000014",
  "black-04": "#0000000a",
  "grey-080": "#000000cc",
  "grey-040": "#00000066",
  "grey-020": "#00000033",
  "grey-016": "#00000029",
  "grey-012": "#0000001f",
  "grey-008": "#00000014",
  "grey-004": "#0000000a",
  "platinum-012": "#435d6b1f",
  "platinum-008": "#435d6b14",
  "platinum-004": "#435d6b0a",
  "teal-050": "#69adb580",
  "teal-020": "#69adb533",
}

const neutral = {
  black: "#000",
  white: "#fff",
  grey,
  platinum,
  alpha,
}

// RED
const red = {
  "1000": "#160e0e",
  "900": "#401c1f",
  "800": "#702d2f",
  "700": "#973b3c",
  "600": "#c74d4d",
  "500": "#f08989",
  "400": "#f5adad",
  "300": "#f5dbdb",
  "200": "#fee9e9",
  "100": "#fff5f5",
  alpha: (alpha: number) => `rgba(236, 78, 78, ${alpha})`,
}

// GREEN
const green = {
  "1000": "#07120e",
  "900": "#122b20",
  "800": "#1e4635",
  "700": "#2b644c",
  "600": "#3f8467",
  "500": "#77aa95",
  "400": "#a5c9ba",
  "300": "#cce5db",
  "200": "#e0f1ea",
  "100": "#effbf6",
  alpha: (alpha: number) => `rgba(54, 182, 129, ${alpha})`,
}

// YELLOW
const yellow = {
  "1000": "#151005",
  "900": "#2d250b",
  "800": "#503f11",
  "700": "#6c5619",
  "600": "#917424",
  "500": "#c59f34",
  "400": "#d4b356",
  "300": "#e7d39d",
  "200": "#f2e7c8",
  "100": "#fdf9ef",
  alpha: (alpha: number) => `rgba(246, 188, 38, ${alpha})`,
}

// LIME
const lime = {
  "1000": "#0f120d",
  "900": "#222817",
  "800": "#394625",
  "700": "#515e36",
  "600": "#6a7e44",
  "500": "#94ac68",
  "400": "#b5c893",
  "300": "#d9e6c1",
  "200": "#eaf0e0",
  "100": "#f5f9ec",
  alpha: (alpha: number) => `rgba(250, 120, 91, ${alpha})`,
}

// SKY
const sky = {
  "1000": "#071217",
  "900": "#0e2734",
  "800": "#214558",
  "700": "#305e76",
  "600": "#4681a1",
  "500": "#63b0d9",
  "400": "#8ac9ea",
  "300": "#c5e3f4",
  "200": "#e6f3f9",
  "100": "#f0faff",
  alpha: (alpha: number) => `rgba(40, 167, 221, ${alpha})`,
}

const blue = {
  "1000": "#0c1018",
  "900": "#1e253e",
  "800": "#33416b",
  "700": "#44568d",
  "600": "#556db4",
  "500": "#8496d2",
  "400": "#b7c1e1",
  "300": "#dce2f4",
  "200": "#eaeefa",
  "100": "#f5f7ff",
  alpha: (alpha: number) => `rgba(77, 140, 240, ${alpha})`,
}

const orange = {
  "1000": "#5a210c",
  "900": "#872f12",
  "800": "#c44217",
  "700": "#e8663b",
  "600": "#ec825f",
  "500": "#eba993",
  "400": "#f5cec2",
  "300": "#f9dfd7",
  "200": "#fbe9e4",
  "100": "#fef8f6",
  alpha: (alpha: number) => `rgba(250, 120, 91, ${alpha})`,
}

const purple = {
  "1000": "#121019",
  "900": "#282436",
  "800": "#483e60",
  "700": "#5c547d",
  "600": "#7a6fa5",
  "500": "#aea1d9",
  "400": "#c5bce5",
  "300": "#e1ddf4",
  "200": "#edeafa",
  "100": "#f7f5ff",
  alpha: (alpha: number) => `rgba(153, 102, 216, ${alpha})`,
}

const pink = {
  "1000": "#160e11",
  "900": "#352129",
  "800": "#5a354a",
  "700": "#7d4862",
  "600": "#a96080",
  "500": "#cc94ab",
  "400": "#e6b3c7",
  "300": "#f3d5e1",
  "200": "#faebf1",
  "100": "#fff5f9",
  alpha: (alpha: number) => `rgba(233, 90, 150, ${alpha})`,
}

const brown = {
  "1000": "#150e0a",
  "900": "#372315",
  "800": "#593a27",
  "700": "#734e36",
  "600": "#976849",
  "500": "#d3976f",
  "400": "#e1b493",
  "300": "#f0d6c2",
  "200": "#f9ebe2",
  "100": "#fdf6f2",
  alpha: (alpha: number) => `rgba(211, 151, 111, ${alpha})`,
}

export const colors = {
  primary,
  neutral,
  red,
  green,
  yellow,
  lime,
  sky,
  blue,
  orange,
  purple,
  pink,
  brown,
  platinum,
}
